import { format } from 'date-fns'
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../index'

type DayPlanState = {
  date: string
}

const initialState: DayPlanState = {
  date: format(new Date(), 'yyyy-MM-dd'),
}

const dayPlanSlice = createSlice({
  name: 'dayPlan',
  initialState: initialState,
  reducers: {
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload
    },
  },
})

export const dayPlanReducer = dayPlanSlice.reducer
export const dayPlanActions = dayPlanSlice.actions

const selectSlice = (state: RootState) => state.dayPlan

export const selectedDateSelector = createSelector(selectSlice, (dayPlanState) => dayPlanState.date)
